<template>
  <div class="app-wrapper">
    <div class="header">
      <div class="info">
        <div class="greet">
          <b>HI，欢迎登录</b>
        </div>
        <div class="sub-title">北京国家粮食交易中心</div>
        <div class="sub-title">粮油竞价交易会报名系统</div>
      </div>
    </div>
    <div class="app-container">
      <div class="card">
        <div class="rows">
          <div class="row">
            <div class="label user">登录信息</div>
            <div class="condition">
              <van-form @submit="login" ref="form">
                <van-field
                  @blur="blur"
                  style="font-size: 1rem"
                  v-model="data.account"
                  placeholder="京粮会员ID或企业全称"
                  :rules="[
                    { required: true, message: '请填入京粮会员ID或企业全称' },
                  ]"
                />
                <van-field
                  @blur="blur"
                  style="font-size: 1rem"
                  v-model="data.password"
                  placeholder="密码"
                  type="password"
                  :rules="[{ required: true, message: '请填写您的登录密码' }]"
                />
              </van-form>
            </div>
          </div>
          <div class="puzzle row">
            <div :class="{ loading }" class="pic-wrap loading">
              <div
                :style="{ backgroundImage: `url(${original})` }"
                class="original"
              />
              <div
                :style="{
                  left: blockX + 'px',
                  backgroundImage: `url(${thumb})`,
                }"
                class="thumb"
              />
              <div :disabled="loading" class="reset-yzm" @click="resetBlock">
                <van-loading v-if="loading" />
                <van-icon v-else name="replay" />
              </div>
            </div>
            <div class="slider-wrap" ref="sliderWrap">
              <van-button
                ref="sliderBlock"
                :loading="loading"
                icon="arrow"
                :style="{ left: blockX + 'px' }"
                class="slider-block"
                type="primary"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="login-btn-wrap">
        <div class="extra-btn flex">
          <div class="forget" @click="dialog.forget = true">
            <van-icon name="question-o" /><span> 忘记密码</span>
          </div>
        </div>
      </div>
    </div>
    <van-dialog v-model="dialog.forget" title="忘记密码" width="90%">
      <div class="tips-wrap">
        <p>如您忘记密码，请联系管理员重置。</p>
        <p>联系电话为010-63564598</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
const md5 = require("md5");
import { base64ToBlob } from "base64-blob";
export default {
  name: "signup",
  data() {
    return {
      data: {
        account: "",
        password: "",
      },
      dialog: {
        forget: false,
      },
      loading: false,
      thumb: "",
      original: "",
      blockX: 0,
    };
  },
  methods: {
    blur() {
      //失去焦点的时候，进行触发
      var u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        //安卓手机
        this.$refs.input.scrollIntoView(false);
      } else {
        window.scroll(0, 0); //苹果
      }
    },
    login() {
      const { account, password } = this.data;
      const { blockX } = this;

      this.loading = true;
      this.$store
        .dispatch("user/login", {
          account,
          password: md5(password),
          position: blockX,
        })
        .then((res) => {
          this.$router.push("/dashboard");
        })
        .catch((err) => {
          console.log("err:", err);
          this.resetBlock();
        })
        .finally((err) => {
          this.loading = false;
        });
    },
    handleDragStart(startX) {
      if (this.loading) return;
      // 获取滑块和容器的尺寸（只在开始拖动时获取，避免重复计算）
      const block = this.$refs.sliderBlock;
      const wrap = this.$refs.sliderWrap;
      const blockRect = block.getBoundingClientRect();
      const wrapRect = wrap.getBoundingClientRect();

      this.sliderInfo = {
        blockWidth: blockRect.width,
        wrapWidth: wrapRect.width,
        wrapLeft: wrapRect.left,
      };

      // 拖动中逻辑
      const handleDragMove = (x) => {
        if (this.loading) return;
        // 计算滑块偏移量（减去初始点击/触摸位置，避免滑块跳动）
        let tmp = x - this.sliderInfo.wrapLeft - startX;
        // 边界限制：不能小于0，不能超过容器宽度-滑块宽度
        tmp = Math.max(
          0,
          Math.min(tmp, this.sliderInfo.wrapWidth - this.sliderInfo.blockWidth)
        );
        this.blockX = tmp;
      };

      // 拖动结束逻辑
      const handleDragEnd = () => {
        // 解绑全局事件，避免内存泄漏
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", handleDragEnd);
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", handleDragEnd);

        // 触发外部验证
        this.login();
      };

      // PC端鼠标移动监听
      const onMouseMove = (e) => {
        e.preventDefault();
        handleDragMove(e.pageX);
      };

      // 移动端触摸移动监听
      const onTouchMove = (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        handleDragMove(touch.pageX);
      };

      // 绑定全局拖动事件
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", handleDragEnd);
      document.addEventListener("touchmove", onTouchMove, { passive: false });
      document.addEventListener("touchend", handleDragEnd);
    },
    resetBlock() {
      if (this.blockX <= 5) {
        this.blockX = 0;
        this.getyzm();
      }
      if (this.blockX > 0) {
        this.blockX -= 5;
        setTimeout(() => {
          this.resetBlock();
        }, 0);
      }
    },
    getyzm() {
      this.loading = true;
      this.$store
        .dispatch("auth/captcha")
        .then(async (res) => {
          this.original = URL.createObjectURL(await base64ToBlob(res.original));
          this.thumb = URL.createObjectURL(await base64ToBlob(res.thumb));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.getyzm();

    // 获取滑块元素（Vue ref 替代原生DOM查询）
    const sliderBlock = this.$refs.sliderBlock;
    // 1. PC端：监听鼠标按下事件
    sliderBlock.addEventListener("mousedown", (e) => {
      e.preventDefault();
      this.handleDragStart(e.layerX); // 传入鼠标点击位置的偏移量
    });

    // 2. 移动端：监听触摸开始事件
    sliderBlock.addEventListener("touchstart", (e) => {
      e.preventDefault();
      const touch = e.touches[0];
      // 计算触摸点在滑块内的偏移量（替代layerX）
      const blockRect = sliderBlock.getBoundingClientRect();
      const startX = touch.clientX - blockRect.left;
      this.handleDragStart(startX);
    });
  },
};
</script>

<style lang="less" scoped>
@main-color: #2a8bf6;

.app-wrapper {
  width: 100%;

  .header {
    padding: 10%;
    height: 250px;
    box-sizing: border-box;
    background: @main-color url("/static/images/header_bg.png") 90% bottom / 40%
      no-repeat;

    .greet {
      font-size: 1.2rem;
      margin-bottom: 5%;
    }

    .sub-title {
      font-size: 1.4rem;
    }
  }

  .info {
    color: #fff;
  }

  .rows {
    font-size: 0.9rem;
    overflow: hidden;

    .row {
      margin: 1rem 0;
    }

    .label {
      color: @main-color;
      margin: 1rem 0;
      box-sizing: border-box;
      padding-left: 1.4rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: left center;

      &.center {
        background-image: url("/static/images/icon_center.png");
      }

      &.user {
        background-image: url("/static/images/icon_user.png");
      }
    }

    .condition {
      color: #505050;
      font-size: 1rem;
      overflow: hidden;
      padding: 2vw 0;

      .van-cell {
        padding: 0.5rem 0;
        border-bottom: 1px solid @main-color;
      }

      .van-cell::after {
        display: none;
      }

      .van-icon {
        color: @main-color;
        float: right;
      }
    }
  }

  .card {
    width: 90%;
    margin: 0 auto 5%;
    padding: 5%;
    background: #fff;
    border-radius: 10px;
    box-shadow: rgba(#000, 0.1) 0 4px 5px;
    box-sizing: border-box;
  }

  .app-container {
    position: absolute;
    top: 50%;
    margin-top: -30%;
    z-index: 1;
    width: 100%;
    overflow: hidden;
  }

  .login-btn-wrap {
    padding: 0 5%;
  }

  .extra-btn {
    margin-top: 5%;

    .forget {
      color: @main-color;
    }
  }

  .tips-wrap {
    padding: 2% 4%;
    box-sizing: border-box;
    line-height: 1.7;

    p {
      font-size: 0.8rem;
    }
  }

  .puzzle {
    width: 300px;
    margin: 0 auto !important;
    transition: all 0.3s;
    .pic-wrap {
      height: 200px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;

      .original {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-repeat: no-repeat;
        background-size: cover;
      }
      .thumb {
        position: absolute;
        z-index: 3;
        top: 0;
        height: 100%;
        width: 50px;
        background-repeat: no-repeat;
        background-size: contain;
      }
      .reset-yzm,
      .back {
        position: absolute;
        padding: 0;
        top: 0;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        z-index: 10;
        font-size: 28px;
        color: #eee;
        text-shadow: 0 0 2px #000;
        border-radius: 4px;
        background: none;
        border: none;
      }
      .reset-yzm {
        right: 0;
      }
    }
    .slider-wrap {
      margin-top: 5px;
      width: 100%;
      position: relative;
      height: 43px;
      overflow: hidden;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
    }
    .slider-block {
      cursor: pointer;
      position: absolute;
      transition: none;
    }
  }
}
</style>
